/**
 * Pure decision for whether the server-rendered tenant seed can be trusted.
 *
 * The seed (lib/dashboard/header-server.ts) is fetched during the RSC render under
 * the user's *cookie session*. While impersonating, that cookie is the ADMIN's real
 * session — the act-as overlay is a per-tab sessionStorage token the server cannot
 * see — so the admin role bypasses RLS and the seed contains EVERY tenant on the
 * platform. Using it would leak tenants outside the acted-as user's allowed set and
 * break tenant switching (the switch route rejects any tenant not in the user's
 * x-hasura-all-tenant-id). So the seed is only trustworthy when NOT impersonating;
 * under impersonation the client refetches under the overlay token instead.
 *
 * Kept dependency-free so it is unit-testable without the browser Apollo/nhost stack.
 */
export function canUseTenantSeed(hasSeed: boolean, impersonating: boolean): boolean {
  return hasSeed && !impersonating
}
